import classNames from 'classnames';
import { Search } from 'lucide-react';
import { Icon } from '@/components/Icon';
import type { FullWidthProps, SharedComponentProps } from '../types';
import * as styles from './index.css';

type SearchInputProps = SharedComponentProps<'input'> &
    FullWidthProps & {
        inputRef?: React.Ref<HTMLInputElement>;
    };

export function SearchInput({ inputRef, fullWidth, className, ...props }: SearchInputProps) {
    return (
        <div className={classNames(styles.wrapper, { [styles.fullWidth]: fullWidth }, className)}>
            <input ref={inputRef} type="text" className={styles.searchInput} {...props} />
            <span className={styles.icon}>
                <Icon icon={Search} size="sm" />
            </span>
        </div>
    );
}
